import { render, staticRenderFns } from "./ChatByTopic.vue?vue&type=template&id=5cb5a1e5&"
import script from "./ChatByTopic.vue?vue&type=script&lang=js&"
export * from "./ChatByTopic.vue?vue&type=script&lang=js&"
import style0 from "./ChatByTopic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports